import ACTIONS, { FETCH_STATUS } from '../constants';
  
export const fetchMeeting = (state) => ({
  type: ACTIONS.FETCH_MEETING_MEETING_CALL,
  payload: state,
});

export const fetchMeetingAttempt = {
  pending: {
    type: ACTIONS.FETCH_MEETING.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.FETCH_MEETING.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.FETCH_MEETING.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};

export const createMeetingRequest = (state) => ({
  type: ACTIONS.CREATE_MEETING_CALL,
  payload: state,
});

export const createMeetingAttempt = {
  pending: {
    type: ACTIONS.CREATE_MEETING.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.CREATE_MEETING.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.CREATE_MEETING.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};

export const updateMeetingRequest = (state) => ({
  type: ACTIONS.UPDATE_MEETING_CALL,
  payload: state,
});

export const updateMeetingAttempt = {
  pending: {
    type: ACTIONS.UPDATE_MEETING.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.UPDATE_MEETING.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.UPDATE_MEETING.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};

export const getMeetings = (state) => ({
  type: ACTIONS.MEETINGS_CALL,
  payload: state,
});

export const getMeetingsAttempt = {
  pending: {
    type: ACTIONS.MEETINGS.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.MEETINGS.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.MEETINGS.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};

export const cancelMeetingRequest = (state) => ({
  type: ACTIONS.CANCEL_MEETING_CALL,
  payload: state,
});

export const cancelMeetingAttempt = {
  pending: {
    type: ACTIONS.CANCEL_MEETING.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.CANCEL_MEETING.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.CANCEL_MEETING.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};
 
export const deleteMeetingRequest = (state) => ({
  type: ACTIONS.DELETE_MEETING_CALL,
  payload: state,
});

export const deleteMeetingAttempt = {
  pending: {
    type: ACTIONS.DELETE_MEETING.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.DELETE_MEETING.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.DELETE_MEETING.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};

export const getMettingsRegistery = (state) => ({
  type: ACTIONS.MEETING_REGISTERY_CALL,
  payload: state,
});

export const getMettingsRegisteryAttempt = {
  pending: {
    type: ACTIONS.MEETING_REGISTERY.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.MEETING_REGISTERY.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.MEETING_REGISTERY.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};

export const clearMeetingReportRequest = (state) => ({
  type: ACTIONS.CLEAR_MEETING_REGISTERY,
});

export const meetingRegistoryRequest = (state) => ({
  type: ACTIONS.MEETING_REGISTERY_PDF_CALL,
  payload: state,
});

export const meetingRegistoryRequestAttempt = {
  pending: {
    type: ACTIONS.MEETING_REGISTERY_PDF.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.MEETING_REGISTERY_PDF.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.MEETING_REGISTERY_PDF.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};

export const sortRegisteryRequest = (state) => ({
  type: ACTIONS.SORT_MEETING_REGISTERY_CALL,
  payload: state,
});

export const sortRegisteryRequestAttempt = {
  pending: {
    type: ACTIONS.SORT_MEETING_REGISTERY.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.SORT_MEETING_REGISTERY.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.SORT_MEETING_REGISTERY.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};
